import { useTranslations } from 'next-intl';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import styles from './bucket-model-dropdown.module.scss';
import { CatHeading } from 'components/blocks-components';

const BucketModelDropdown = () => {
  const t = useTranslations();

  return (
    <>
      <div className="d-flex align-items-center">
        <CatHeading variant="label" className="me-1">
          {t('BUCKET_MODEL_NO')}
        </CatHeading>
        <CatHeading variant="footnote">{t('OPTIONAL')}</CatHeading>
      </div>
      <div className={styles['bucket-model-dropdown']}>
        <CatDropdown
          ariaDescribedBy="bucket-get-search-field"
          fieldId="bucket-model-dropdown"
          fieldNote={t('BUCKET_MODEL_NO_PLACEHOLDER')}
          isTypeahead
          hideLabel
          size="md"
          data-testid="bucket-model-dropdown"
        />
      </div>
    </>
  );
};

export default BucketModelDropdown;
